import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _ from 'lodash';

import ToastAx        from 'app/actions/toast';
import Modal          from 'app/components/common/modal';
import MultiEmpSelect from 'app/components/company-admin/common/multi-emp-select';
import GrantSysDuck   from 'app/ducks/company-admin/grant-system';
import prompts        from 'app/prompts';
import AuthSlx        from 'app/selectors/auth';

class ModalProgramAdmins extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      adminIds: null,
    };

    this.onChangeEmps = this.onChangeEmps.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  get hasLoaded() {
    // TODO: may need to fetch these upon mount
    // at the moment, this modal is only opened from a page where this is already loaded
    return !!this.props.program?.adminIds;
  }
  get hasChanges() {
    if (this.state.adminIds == null) return false;
    if (this.props.program?.adminIds == null) return false;
    const oldKey = this.props.program.adminIds.join('|');
    const newKey = this.state.adminIds.join('|');
    return oldKey !== newKey;
  }
  get wasInList() {
    return this.props.program.adminIds.includes(this.props.currentEmp.id);
  }
  get isInList() {
    return this.state.adminIds.includes(this.props.currentEmp.id);
  }
  get didRemoveSelf() {
    return this.wasInList && !this.isInList;
  }

  onChangeEmps(mesComp) {
    const adminIds = mesComp.selectedEmployeeIds;
    this.setState({adminIds});
  }

  async onClickSave() {
    if (this.didRemoveSelf) {
      const msg = `Are you sure you want to remove yourself as an admin of this program?`;
      const didConfirm = await prompts.confirm({msg, confirmBtnLabel: 'Save Changes'});
      if (!didConfirm) return;
    }
    this.props.save(this.state.adminIds).then(() => {
      this.props.onClose();
      this.props.toastSuccess('Program admins updated.');
    });
  }

  render() {
    const {program, company, updatePending} = this.props;
    if (!program || !company) return null;
    if (!this.hasLoaded) return null;
    const btnDisabled = !this.hasChanges || updatePending;

    return (
      <Modal onClose={this.props.onClose} className="bform">
        <h1 className="bform-h1">Manage Program Admins</h1>

        <label className="bform-h3">Admins</label>
        <MultiEmpSelect onChange={this.onChangeEmps} initialEmployeeIds={program.adminIds} />
        
        <div className="bform-actions">
          <div className="bform-actions-right">
            <button className="btn blue" onClick={this.onClickSave} disabled={btnDisabled}>{updatePending ? 'Saving...' : 'Save Changes'}</button>
          </div>
        </div>
      </Modal>
    );
  }
}

ModalProgramAdmins.propTypes = {
  company: PropTypes.object.isRequired,
  program: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

const stateToProps = (state) => ({
  currentEmp: AuthSlx.currentEmp(state),
  updatePending: GrantSysDuck.Slx.progUpdateAdminsPending(state),
});
const dispatchToProps = (dispatch, ownProps) => ({
  save: (adminIds) => dispatch(GrantSysDuck.Ax.programsUpdateAdmins(ownProps.company.id, ownProps.program.id, adminIds)),
  toastSuccess: (msg) => dispatch(ToastAx.success(msg)),
});

export default connect(stateToProps, dispatchToProps)(ModalProgramAdmins);
